import styled from 'styled-components';
import { ContainerCustom } from 'components';

export const DescriptionWrapper = styled(ContainerCustom)`
  h1 {
    color: #353535;
    margin: 0 0 30px 0;
    font-size: 36px;
    font-weight: 500;
    font-family: 'Ubuntu';
    @media ${({ theme }) => theme.device.laptop1100} {
      font-size: ${({ size1100 }) => size1100 || '24px'};
    }
  }

  h2 {
    color: #353535;
    font-size: 24px;
    font-weight: 500;
    font-family: 'Ubuntu';
    margin: 30px 0 20px 0;

    @media ${({ theme }) => theme.device.laptop1100} {
      font-size: ${({ size1100 }) => size1100 || '18px'};
    }
  }

  p {
    color: #353535;
    font-size: 16px;
    margin: 20px 0 29px 0;
    line-height: 140%;
    font-family: 'Rubik';
  }
`;
